import { render, staticRenderFns } from "./SiteGroup.vue?vue&type=template&id=519e0b72&scoped=true"
import script from "./SiteGroup.vue?vue&type=script&lang=js"
export * from "./SiteGroup.vue?vue&type=script&lang=js"
import style0 from "./SiteGroup.vue?vue&type=style&index=0&id=519e0b72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519e0b72",
  null
  
)

export default component.exports